import "./SettingsForm.css";
import { Col, Form } from "react-bootstrap";

export default function SettingsVideoForm(props) {
  // Video form for the admin's settings page
  // allows the user to add or delete videos, provides a preview of selected video

  return (
    <>
      <Form.Group className="mb-3" controlId={props.name}>
        <Form.Label>
          <b>Top Video</b>
        </Form.Label>
        <Form.Control
          name={props.name}
          type="file"
          accept="video/*"
          onChange={async (event) => {
            const video = event.target.files[0];
            if (props.settingsData?.[props.name]?.public_id) {
              props.setDeletedVideosPublicIds([
                ...props.deletedVideosPublicIds,
                props.settingsData[props.name].public_id,
              ]);
            }
            props.setNewVideo(video);
            props.handleChange(event); //formik's
            event.target.value = null; // Clear input manually, else onChange won't run if choose same image again
          }}
        />
      </Form.Group>

      {/* selected video preview */}
      {props.values?.[props.name] && (
        <Col>
          <div style={{ position: "relative", display: "flex", marginBottom: "15px" }}>
            {props.newVideo ? (
              <div>
                <video
                  className="settings-preview-file"
                  controls
                  src={URL.createObjectURL(props.newVideo)}
                >
                  {props.newVideo?.name}
                </video>
              </div>
            ) : (
              props.settingsData?.[props.name] &&
              props.settingsData?.[props.name]?.public_id && (
                <video className="settings-preview-file" controls>
                  <source
                    src={props.settingsData?.[props.name]?.url}
                    type={`video/${props.settingsData?.[props.name]?.format}`}
                  />
                </video>
              )
            )}
            <i
              className="bi bi-x-circle media-x-button"
              onClick={() => {
                if (props.newVideo) {
                  props.setNewVideo(null);
                } else {
                  props.setDeletedVideosPublicIds([
                    ...props.deletedVideosPublicIds,
                    props.settingsData?.[props.name]?.public_id,
                  ]);
                  props.setDeletedFiles({
                    ...props.deletedFiles,
                    [props.name]: true,
                  });
                }
                props.handleChange({
                  target: {
                    name: props.name,
                    value: "",
                  },
                });
              }}
            ></i>
          </div>
        </Col>
      )}
    </>
  );
}
